<div class="dialog-headline">{{data.title}}</div>
<div mat-dialog-content>
  <h3 class="text-red-800">{{data.content}}</h3>
</div>
<div mat-dialog-actions class="flex justify-end">
  <button mat-raised-button color="warn" [mat-dialog-close]="true">Yes</button>
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial>No</button>
</div>
